
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.128 10.883a8.348 8.348 0 00-5.504-2.074c-3.318 0-6.174 1.93-7.53 4.73-.255.535.032 1.173.598 1.365a.98.98 0 001.197-.51 6.385 6.385 0 015.735-3.59 6.36 6.36 0 014.084 1.5l-1.523 1.523c-.503.502-.152 1.364.558 1.364h4.46a.8.8 0 00.797-.798V9.934c0-.71-.861-1.069-1.364-.566l-1.508 1.515z"}})])
          )
        }
      }
    